import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { SearchBar } from "./SearchBar";
import { ButtonIcon } from "./TableSettingsComponents";
import { IconType } from "react-icons";

interface ICMSPageHeader {
  title: string;
  button?: {
    title: string;
    icon: IconType;
    onClick: () => void;
  };
  onSearch?: (query: string) => void;
  searchValue?: string;
  count?: number;
  filterSlot?: React.ReactNode;
}

const CMSPageHeader: React.FC<ICMSPageHeader> = (props) => {
  const theme = useTheme();
  const { title, count, button, onSearch, searchValue, filterSlot } = props;

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          py: "1rem",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            textTransform: "capitalize",
            color: theme.palette.primary.light,
            paddingRight: "1rem",
          }}
        >
          {count}
        </Typography>
        <Typography variant="h2">{title}</Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexGrow: "4",
          }}
        >
          {button && (
            <Button
              variant="outlined"
              size="small"
              sx={{ marginLeft: "2rem", display: "flex" }}
              onClick={button.onClick}
            >
              <ButtonIcon>
                <button.icon />
              </ButtonIcon>
              <Typography variant="button">{button.title}</Typography>
            </Button>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "auto",
              gap: "0.5rem",
            }}
          >
            {filterSlot}
            {onSearch && (
              <SearchBar onSearch={onSearch} initialValue={searchValue} />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CMSPageHeader;
